import React, { useEffect, useState } from 'react'
import { TableCustom } from '../../components/Table'
import useAxiosInstance from '../../hooks/useAxios';
import { OBSERVABILITY_LOGS_TABLE_KEYS, OBSERVABILITY_METRICS_TABLE_KEYS } from '../../helper';
import { Paginator } from '../../components/Paginator';
import Select from "react-select";
import { useSelector } from 'react-redux';
import Input from '../../components/input';
import { useDebounce } from 'use-debounce';

const ObservabilityLogs = () => {
    const axiosInstance = useAxiosInstance()
    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [intermidiatePageNumber, setIntermidiatePageNumber] = useState(1)
    const [pageSize, setPageSize] = useState(50)
    const [data, setData] = useState({})
    const [viewStatus, setViewStatus] = useState([])
    const [viewName, setViewName] = useState([])
    const [reportID, setReportID] = useState("")
    const [reportQuery] = useDebounce(reportID, 1000)
    const [reportCategory, setReportReportCategory] = useState([])
    const { allViews, allReportCategory } = useSelector((state) => state.globalAuth);

    useEffect(() => {
        setLoading(true);
        const controller = new AbortController();
        axiosInstance
            .post(
                `/workflow_manager/get_observability_table/`,
                {
                    "page": page,
                    "page_size": Number(pageSize),
                    "view_status": viewStatus.map(it => it.value),
                    "view_names": viewName.map(it => it.value),
                    "report_id": reportQuery,
                    "category": reportCategory.map(it => it.value)
                }
                ,
                {
                    signal: controller.signal
                }
            )
            .then((res) => {
                setData(res.data);
                setLoading(false);
                setIntermidiatePageNumber(res.data.current_page)
            })
            .catch((err) => {
                console.log(err);
            });

        return () => {
            controller.abort();
        };
    }, [page, pageSize, viewStatus, viewName, reportQuery, reportCategory]);

    useEffect(() => {
        setPage(1)
        setIntermidiatePageNumber(1)
    }, [pageSize, viewStatus, viewName, reportQuery, reportCategory])

    const statusOptions = [
        {
            "value": "success",
            "label": "Success"
        },
        {
            "value": "failed",
            "label": "Failed"
        },
        {
            "value": "not started",
            "label": "Not started"
        },
        {
            "value": "no data",
            "label": "No data"
        }
    ]
    return (
        <div className="p-2 overflow-x-auto bg-white mt-4 rounded-xl mr-3 border">
            <div className="flex justify-between mb-5">
                <span className="text-xl font-medium">Observability Metrics</span>
            </div>

            <div className='flex justify-between gap-x-3'>
                <div className='w-full'>
                    <p className="text-sm font-semibold mb-2 ">Select Status</p>
                    <Select
                        className="w-full"
                        options={statusOptions}
                        isMulti
                        value={
                            viewStatus
                        }
                        onChange={(e) => {
                            setViewStatus(e)
                        }}
                    />
                </div>
                <div className='w-full'>
                    <p className="text-sm font-semibold mb-2">Select Views</p>
                    <Select
                        className="w-full"
                        options={allViews}
                        isMulti
                        value={
                            viewName
                        }
                        onChange={(e) => {
                            setViewName(e)
                        }}
                    />
                </div>
            </div>
            <div className='flex justify-between mt-3 gap-x-3'>
                <div className='w-full'>
                    <p className="text-sm font-semibold mb-2 ">Search Report ID</p>
                    <Input
                        value={reportID}
                        onChange={e => setReportID(e.target.value)}
                        placeholder={'report id...'}
                    />
                </div>
                <div className='w-full'>
                    <p className="text-sm font-semibold mb-2">Select Category</p>
                    <Select
                        className="w-full"
                        options={allReportCategory.map(elem => ({ "label": elem.label, "value": elem.label }))}
                        isMulti
                        value={
                            reportCategory
                        }
                        onChange={(e) => {
                            setReportReportCategory(e)
                        }}
                    />
                </div>
            </div>

            <div>
                <TableCustom
                    columns={OBSERVABILITY_LOGS_TABLE_KEYS}
                    data={data}
                    loading={loading}
                    className='min-h-[65vh] !max-h-[65vh]'
                />
                <Paginator
                    data={data}
                    loading={loading}
                    setPage={setPage}
                    setIntermidiatePageNumber={setIntermidiatePageNumber}
                    intermidiatePageNumber={intermidiatePageNumber}
                    setPageSize={setPageSize}
                    pageSize={pageSize}
                />
            </div>
        </div>
    )
}

export default ObservabilityLogs